// extracted by mini-css-extract-plugin
export default {"container":"s02_container__BddgU","desc":"s02_desc__Aphdm","enable":"s02_enable__f-Sy3","observe":"s02_observe__Br2EV"};